module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAACmAAAApgHdff84AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAABhQTFRF/////Wlx/l1nQUebUVej9fX1+4qR/0tVDsW5DwAAAAN0Uk5TAPT7oMnL8wAAACxJREFUGFdjYCAdMAoJwNn/WVKRZFje4+IwIbGJVYabwyKIi0OkMhQvMJABAPg0BthuVqqCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/template/thailand.png
// module id = 673
// module chunks = 0